enum AdNetworkSignalEvent {
    StartedWorkingWith = "StartedWorkingWith",
    StoppedWorkingWith = "StoppedWorkingWith",
}

export default AdNetworkSignalEvent;
